import { OrientationTypes } from "@enums/orientation-types";
import { ImageDimension } from "@idw-types/common/image-dimension";
import { CaptureStepTypes } from "@enums/capture-step-types";
import { Logger } from "./logger";


export const getFormattedFileSize = (fileSize: number): string => {
    if (fileSize < 1024) {
        return fileSize + 'bytes';
    } else if (fileSize >= 1024 && fileSize < 1048576) {
        return (fileSize / 1024).toFixed(1) + 'KB';
    } else {
        return (fileSize / 1048576).toFixed(1) + 'MB';
    }
};

export const getBase64Size = (base64: string): number => {
    if (!base64) {
        return -1;
    }
    // tslint:disable-next-line:variable-name
    const [head, content_without_mime] = base64.split(',');
    if (!content_without_mime) {
        return -1;
    }
    let sizeInBytes;
    try {
        sizeInBytes = Buffer.from(content_without_mime, 'base64').length;
    } catch (error) {
        console.log(`atob not supported, falling back to guestimate size. Error message: ${error}`);
        // If atob is not supported on the browser
        sizeInBytes = Math.round(((content_without_mime.length - head.length) * 3) / 4);
    }

    return sizeInBytes;
}

export const getImageOrientation = (image: HTMLImageElement) => {
    if (image.naturalWidth > image.naturalHeight) {
        return OrientationTypes.LANDSCAPE;
    } else if (image.naturalWidth < image.naturalHeight) {
        return OrientationTypes.PORTRAIT;
    }
    return OrientationTypes.ANY;
};

const calculateAspectRatioFit = (
    srcWidth: number,
    srcHeight: number,
    maxWidth: number,
    maxHeight: number
): ImageDimension => {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export const getPreviewDimensions = (captureStepType: CaptureStepTypes, previewWidth: number, previewHeight: number) => {
    let width = 280;
    let height = 210;

    if (captureStepType === CaptureStepTypes.FACE) {
        width = 200;
        height = 150;
    }

    const imageRatio = previewWidth / previewHeight;
    Logger.info(`[CapturePreviewImageService] Preview image -  ratio: ${imageRatio}`);
    if (imageRatio > 1) {
        width = Math.ceil(height * imageRatio);
        Logger.info(`[CapturePreviewImageService] Preview image - adjust width to ${width}`);
    } else {
        height = Math.ceil(width / imageRatio);
        Logger.info(`[CapturePreviewImageService] Preview image - adjust image height to ${height} `);
    }

    const previewDimensions = calculateAspectRatioFit(previewWidth, previewHeight, width, height);
    Logger.info("[CapturePreviewImageService] Preview image - scaled resolution: ", previewDimensions);
    Logger.info('[CapturePreviewImageService] *************** PREVIEW IMAGE DIMENSIONS COMPLETE ***************');
    return previewDimensions;
};